import { useCallback } from "react";

import type { VoucherListInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { VoucherListUpdate_TopPage_Mutation } from "./mutation";

export const useVoucherListUpdate = () => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(VoucherListUpdate_TopPage_Mutation, {});

	const onUpdateVoucherList = useCallback(
		(
			input: VoucherListInput, //
		) => {
			showLoadingScreenCallback();

			mutationFunc({
				variables: {
					input,
				},
			})
				.then(({ errors }) => {
					if (!errors) {
						notifyUserEventInfo({
							variant: "default",
							title: "宿泊券の並び順を更新しました",
						});
					}
				})
				.finally(() => {
					hideLoadingScreenCallback();
				});
		},
		[hideLoadingScreenCallback, mutationFunc, showLoadingScreenCallback],
	);

	return {
		onUpdateVoucherList,
	};
};
